import {
  IApiResponse,
  IFetchMmsSales,
  IMmsSales,
  ISingleSalesResponse,
} from '@/services/mmsSales/mmsSales.types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MmsSalesState {
  mmsSales: IApiResponse;
  loading: boolean;
  error: boolean;
  mmsSalesById: ISingleSalesResponse;
}

export const initialState: MmsSalesState = {
  mmsSales: {
    data: [],
    pagination: {
      totalItems: 0,
      currentPage: 0,
      numberOfPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: '',
  },
  mmsSalesById: {
    data: {} as IMmsSales,
    message: 'Succesfully grabbed order',
    success: true,
  },
  loading: false,
  error: false,
};

const mmsSalesSlice = createSlice({
  name: 'mmsSales',
  initialState,
  reducers: {
    getMmsSales: (state, action: PayloadAction<IFetchMmsSales>) => {
      state.loading = true;
    },
    getMmsSalesSuccess: (state, action: PayloadAction<IApiResponse>) => {
      state.loading = false;
      state.mmsSales = { ...action.payload };
    },
    getMmsSalesRecordById: (state, action: PayloadAction<IFetchMmsSales>) => {
      state.loading = true;
    },
    getSalesRecordSuccess: (
      state,
      action: PayloadAction<ISingleSalesResponse>,
    ) => {
      state.loading = false;
      state.mmsSalesById = { ...action.payload };
    },
    getSalesRecordFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
      state.mmsSalesById = { ...initialState?.mmsSalesById };
    },
    getMmsSalesFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
      state.mmsSales = {
        ...initialState.mmsSales,
        success: false,
        message: action.payload?.messageDetails?.length
          ? action.payload.messageDetails[0]?.message
          : action.payload?.message || 'An unexpected error occurred',
      };
    },
    clearMmsSalesError: (state) => {
      state.error = false;
    },
  },
});

const mmsSalesReducer = mmsSalesSlice.reducer;

export const {
  getMmsSales,
  getMmsSalesSuccess,
  getMmsSalesFailure,
  getMmsSalesRecordById,
  getSalesRecordSuccess,
  getSalesRecordFailure,
  clearMmsSalesError,
} = mmsSalesSlice.actions;

export default mmsSalesReducer;
